import { render, staticRenderFns } from "./CoronaModal.vue?vue&type=template&id=f1d55e6c&scoped=true&"
import script from "./CoronaModal.vue?vue&type=script&lang=js&"
export * from "./CoronaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d55e6c",
  null
  
)

export default component.exports